import * as React from "react";

export class Events extends React.Component<{}, {}> {
    render() {
        return (
            <div className="rj-racing-current-races__events-wrapper"><div className="rj-racing-current-races__events">{this.props.children}</div></div>
        )
    }
}